import { useQuery } from "@tanstack/react-query";
import organizationsSAService from "services/superadmin/organizationsSAService";

export const useGetOrg = (orgID) => {
    return useQuery({
        queryKey: ['getOrg', orgID],
        enabled: !!orgID,
        queryFn: async () => {
            const { data } = await organizationsSAService.get(orgID)
            return data
        },
        refetchOnWindowFocus: false,
        retry: false,
    })
}